import { cellText } from '@/lib/daily-reports/cells';

const DSP_WITH_LOCATION = /^(\d+)\s*-\s*(.+)$/;
const DSP_ID_ONLY = /^(\d+)$/;

/** Split `134232 - VIC BBY NAI` into the SPA id and the branch note. */
export function parseDspCell(value: unknown): {
  spaId: string;
  location: string;
} {
  const text = cellText(value);
  const withLocation = DSP_WITH_LOCATION.exec(text);
  if (withLocation) {
    return {
      spaId: withLocation[1] ?? '',
      location: cellText(withLocation[2]),
    };
  }
  const idOnly = DSP_ID_ONLY.exec(text);
  if (idOnly) return { spaId: idOnly[1] ?? '', location: '' };
  return { spaId: text, location: '' };
}

/** `WJ - BC DSPs` → `BC`; unknown names stay as the sheet title. */
export function regionFromFlatSheetName(sheetName: string): string {
  const stripped = sheetName
    .replace(/^WJ\s*-?\s*/i, '')
    .replace(/\s*DSPs?\s*$/i, '')
    .trim();
  return stripped === '' ? sheetName : stripped;
}
